// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
'use strict';
export { default as RNRenderer } from 'react-native/Libraries/Renderer/shims/ReactNative';
